import React from 'react';

import { forNamespace } from 'app/common/lib/util/i18n';

import { KnownService, KnownServiceComponentProps } from './known-service';

import styles from './styles.less';

const format = forNamespace('known services');

interface OwnProps extends KnownServiceComponentProps {
  url: string;
  user: string;
  repo: string;
  issueNumber: string;
}

export const GitHubIssueComponent: React.FunctionComponent<OwnProps> = ({
  user,
  url,
  repo,
  issueNumber,
  ...anchorProps
}) => (
  <a {...anchorProps} href={url} className={styles.knownServiceLink}>
    <img
      className={styles.knownServiceIcon}
      alt="Github Icon"
      src={require('resources/images/services/github.png')}
    />
    {format(['github issue', 'text'], { user, repo, number: issueNumber })}
  </a>
);

export const GitHubIssue: KnownService<OwnProps> = {
  match: {
    protocol: 'https:',
    host: 'github.com',
    pathname: new RegExp(`\
^\
/\
([^/]+)/\
([^/]+)/\
issues/\
(\\d+)\
$\
`),
  },
  getMatchProps: ([url, _, user, repo, issueNumber]: string[]) => {
    return { url, user, repo, issueNumber };
  },
  Component: GitHubIssueComponent,
};
